import { useEffect } from 'react';
import {
  useAnalytics,
  METRICS_DIM_VIDEO_PLAY,
  METRICS_DIM_VIDEO_NAME,
} from '@xolv-mybrightlink/common';

export const useDimensionVideoEvent = (postTitle: string) => {
  const analytics = useAnalytics();
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data === 'play') {
        analytics.trackAction(METRICS_DIM_VIDEO_PLAY, {
          [METRICS_DIM_VIDEO_NAME]: postTitle,
        });
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [analytics, postTitle]);
};
